import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const ParkingWarningSvgIcon = createSvgIcon([
    React.createElement("path", { key: '0', fill: '#1A1A1A', d: 'M12,0.6L0.6,23.4h22.8L12,0.6z' }),
    React.createElement("path", { key: '1', fill: '#FFCC00', d: 'M12,3.4L3.2,21.2h17.6L12,3.4z' }),
    React.createElement("path", { key: '2', fill: '#1A1A1A', d: 'M10.9,9h2.2v6.1h-2.2V9z M10.9,16.4h2.2v2.2h-2.2V16.4z' }),
], 'TransportConditionParkingWarningIcon');
const TransportConditionParkingWarningIcon = function (props) {
    return React.createElement(ParkingWarningSvgIcon, Object.assign({}, props));
};
export default memo(TransportConditionParkingWarningIcon);
